import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Modal, Button } from '../../../components/common';
import CmsField from '../../cms/components/CmsField';
import { invoiceService } from '../../../services/invoiceService';
import { getApiError, getApiFieldErrors } from '../../../services/cmsService';

/** Cancel an issued invoice. The number is kept; its projects return to pending. */
const CancelInvoiceModal = ({ isOpen, onClose, invoice, onCancelled }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setReason('');
      setError('');
    }
  }, [isOpen]);

  const handleCancel = async () => {
    if (reason.trim().length < 3) {
      setError('Give a reason of at least 3 characters');
      return;
    }
    setSaving(true);
    try {
      const updated = await invoiceService.cancel(invoice.id, reason.trim());
      toast.success(`Invoice ${updated.number} cancelled`);
      onCancelled?.(updated);
      onClose();
    } catch (err) {
      const api = getApiFieldErrors(err);
      setError(api.reason || api.invoice || '');
      toast.error(getApiError(err, 'Failed to cancel the invoice'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Cancel invoice ${invoice?.number ?? ''}`}
      size="medium"
      closeOnOverlay={false}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={saving}>Keep invoice</Button>
          <Button variant="danger" onClick={handleCancel} loading={saving}>Cancel invoice</Button>
        </>
      }
    >
      <div className="bl-form-stack">
        <p className="bl-muted">
          The invoice keeps its number and is marked CANCELLED. Its projects go back to pending so they can be
          billed again. Invoices that still have payments can’t be cancelled — delete the payments first.
        </p>
        <CmsField
          id="cancel-reason"
          type="textarea"
          label="Reason"
          required
          rows={3}
          placeholder="e.g. Wrong GSTIN on the invoice; re-issued as a new invoice"
          value={reason}
          onChange={(v) => {
            setReason(v);
            setError('');
          }}
          error={error}
          hint="Kept in the invoice history. The PDF gets a CANCELLED watermark."
        />
      </div>
    </Modal>
  );
};

export default CancelInvoiceModal;
